import { Injectable } from "@angular/core";
import { CommandInput, CommandService, CommandTemplate, EditDialogService, Flow, HasCommands } from "@nexato/nx-core-module";
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { TourInput } from '../../shared/entities/tour';
@Injectable({
    providedIn: 'root'
  })
export class TourCreateCommandCustomFlow implements Flow {

  dialogRef: DynamicDialogRef | undefined;

  constructor(
    private dialogService: EditDialogService
  ) { }

  executeFlow(commandService: CommandService, hasCommands: HasCommands,
    commandTemplate: CommandTemplate, commandInput: CommandInput,
    completionCallback: () => void) {

      // must be set, otherwise the command is disabled
      let locationId = commandTemplate?.flow?.settings?.customFlowSettings?.locationId;
      let dateTimeReference = commandTemplate?.flow?.settings?.customFlowSettings?.dateTimeReference;
      let tourInput = new TourInput();
      tourInput.locationId = locationId;
      tourInput.dateTimeReference = dateTimeReference;
      let parameterObject = {
        tourInput: tourInput
      }
      commandInput.parameters = parameterObject;
      commandService.sendCommand(commandInput, () => {
        completionCallback();
      })
  }
  
}